<template>
  <layout-with-back-btn
    :title="pageTitle"
  >
    <template #header-right>
      <div
        class="d-inline flex"
        :class="status.class"
      >
        {{ status.text }}
      </div>
    </template>

    <div
      v-if="loading"
      class="mx-[20px] flex items-center justify-center gap-[10px]"
    >
      <b-spinner
        v-if="loading"
        variant="primary"
      />
      <p class="mb-0">
        Memuat data...
      </p>
    </div>
    <div
      v-else-if="isError"
      class="mx-[20px] flex items-center justify-center gap-[10px]"
    >
      <p class="mb-0">
        Gagal mengambil data, silahkan coba lagi.
      </p>
    </div>
    <div
      v-else
    >
      <div class="text-black my-[30px]">
        <div class="fulfillment-detail-card">
          <p class="fulfillment-detail-card_title">
            Mitra Gudang
          </p>
          <div class="flex items-start gap-[10px]">
            <span>:</span>
            <div>
              <p>
                {{ detail.warehouse_name }}
              </p>
              <p class="text-[#666666]">
                {{ detail.city_name }}
              </p>
            </div>
          </div>
        </div>
        <div class="fulfillment-detail-card">
          <p class="fulfillment-detail-card_title">
            Metode Pengiriman
          </p>
          <div class="flex items-start gap-[10px]">
            <span>:</span>
            <p>{{ detail.shipping_type }}</p>
          </div>
        </div>
        <div class="fulfillment-detail-card">
          <p class="fulfillment-detail-card_title">
            Tanggal Pengambilan
          </p>
          <div class="flex items-start gap-[10px]">
            <span>:</span>
            <p>{{ DAY_MONTH_YEAR(detail.outbound_date) }}</p>
          </div>
        </div>
      </div>

      <b-table
        class="mb-0"
        empty-text="Tidak ada data yang ditampilkan."
        show-empty
        responsive
        :fields="fieldsDetailPenarikan"
        :items="detail.products"
      >
        <template #cell(variant)="data">
          <div v-if="data.item.variant === ''">
            -
          </div>
          <div v-else>
            {{ data.item.variant }}
          </div>
        </template>
        <template #cell(fulfillment_cost)="data">
          <div>
            {{ data.item.fulfillment_cost }} <span class="text-success">+{{ data.item.addon_cost }}/{{ data.item.addon_minimum }}pcs</span>
          </div>
        </template>
        <template #head(pengeluaran_cost)="data">
          <div class="d-flex align-items-center">
            {{ data.label }}
            <div class="ml-[11px]">
              <img
                id="addonPopover"
                src="https://storage.googleapis.com/komerce/assets/icons/info-circle.svg"
                alt="Komerce"
              >
              <b-popover
                triggers="hover"
                target="addonPopover"
                placement="top"
              >
                Biaya ini sudah dihitung dengan  skema biaya tambahan,
                Sehingga kamu sudah mendapatkan biaya termurah!
              </b-popover>
            </div>
          </div>
        </template>
        <template #cell(pengeluaran_cost)="data">
          <div>
            {{ data.item.total_cost | rupiah }}
          </div>
        </template>
      </b-table>

      <div
        v-if="detail.memo"
        class="mt-[8px]"
      >
        <label
          class="text-black ml-[16px]"
        >
          Catatan:
        </label>
        <p
          class="text-black border border-[#E0E0E0] rounded-[8px] p-[16px]"
        >
          {{ detail.memo }}
        </p>
      </div>

      <div
        v-if="isPenarikanBarang"
        class="d-flex justify-end flex-col items-end py-2 gap-[16px]"
      >
        <div class="w-full sm:w-50 border-b-2 pb-[16px] border-dashed">
          <div class="d-flex justify-between mb-[4px]">
            <div class="text-black">
              Total biaya pengeluaran
            </div>
            <div class="text-black ">
              {{ detail.fulfillment_fee ? detail.fulfillment_fee : 0 | rupiah }}
            </div>
          </div>
          <div class="d-flex justify-between mb-[8px]">
            <div class="text-black">
              Potongan 50%
            </div>
            <div class="text-success ">
              {{ fulfillmentAfterPotongan | rupiah }}
            </div>
          </div>
          <div class="d-flex justify-between">
            <div class="font-weight-bolder text-black">
              Total Pembayaran
            </div>
            <div class="font-weight-bolder text-primary ">
              {{ fulfillmentAfterPotongan | rupiah }}
            </div>
          </div>
        </div>
        <div class="w-full sm:w-50">
          <div class="d-flex justify-between mb-[4px]">
            <div class="text-black">
              Komisi Mitra Gudang
            </div>
            <div class="text-black ">
              {{ sharingFeeMitra | rupiah }}
            </div>
          </div>
          <div class="d-flex justify-between mb-[8px]">
            <div class="text-black">
              Komisi Kompack
            </div>
            <div class="text-success ">
              {{ fulfillmentAfterPotongan - sharingFeeMitra | rupiah }}
            </div>
          </div>
        </div>
      </div>
    </div>

  </layout-with-back-btn>
</template>

<script>
import { DAY_MONTH_YEAR } from '@/libs/filterDate'
import LayoutWithBackBtn from '@/views/pages/kompack/LayoutWithBackBtn.vue'
import fieldsDetailPenarikan from './config'

/**
 * Component untuk menampilkan detail penarikan kompack
 * @component PenarikanDetail
 */
export default {
  name: 'PenarikanDetail',
  components: {
    LayoutWithBackBtn,
  },
  data() {
    return {
      loading: true,
      isError: false,
      detail: {},
    }
  },
  computed: {
    pageTitle() {
      return `Detail ${this.detail.outbound_type || 'Penarikan'}`
    },
    isPenarikanBarang() {
      return this.detail.outbound_type === 'Penarikan Barang'
    },
    status() {
      return {
        text: this.handleStatus('text', this.detail.status, this.detail.outbound_type),
        class: this.handleStatus('class', this.detail.status, this.detail.outbound_type),
      }
    },
    /**
     * Menghitung biaya fulfillment setelah potongan 50%
     * @returns {number} Biaya setelah potongan
     */
    fulfillmentAfterPotongan() {
      return this.detail.fulfillment_fee / 2
    },
    /**
     * Menghitung komisi untuk mitra gudang
     * @returns {number} Komisi mitra
     */
    sharingFeeMitra() {
      return this.fulfillmentAfterPotongan * this.detail.percentage_sharing_fee
    },
  },
  created() {
    this.fieldsDetailPenarikan = fieldsDetailPenarikan
  },
  mounted() {
    this.fnFetchData()
  },
  methods: {
    DAY_MONTH_YEAR,
    /**
     * Handle status display (class atau text)
     * @param {string} part - 'class' atau 'text'
     * @param {string} status - Status penarikan
     * @param {string} type - Type penarikan
     * @returns {string} CSS class atau text sesuai status
     */
    handleStatus(part, status, type) {
      if (part === 'class') {
        if (status === 'Diajukan') return 'status status-waiting'
        if (status === 'Selesai') return 'status status-done'
        if (status === 'Ditolak') return 'status status-reject'
        if (status === 'Diproses') return 'status status-acc'
      }
      if (status === 'Diajukan' && type === 'Barang Rusak') return 'Menunggu respon partner'
      if (status === 'Diajukan' && type === 'Penarikan Barang') return 'Menunggu respon mitra'
      if (status === 'Diproses') return 'Disetujui'
      return status
    },
    async fnFetchData() {
      try {
        const { data } = await this.$http_new.get(`/komship/api/v1/admin/outbounds/withdrawal/${this.$route.params.id}`)
        this.detail = data.data
      } catch (error) {
        this.isError = true
      }
      this.loading = false
    },
  },
}
</script>

<style lang="scss" scoped>
.alert {
   background-color: #FFF2E2;
   color: #F95031;
   border-radius: 8px;
   padding: 10px;
}
.status {
  padding: 2px 8px;
  border-radius: 100px;
  text-align: center;
  &-acc {
    color: #34A770;
    background: #DCF3EB;
  }
  &-waiting {
    color: #FBA63C;
    background: #FFF2E2;
  }
  &-done {
    color: #4285F4;
    background: #DFF3FF;
  }
  &-reject {
    color: #E31A1A;
    background: #FFEDED;  }
}

.fulfillment-detail-card {
    display: flex;
    flex-direction: row;
    align-items: flex-start;
    gap: 10px;
    margin-bottom: 10px;

    p {
        margin: 0;
    }
}
.fulfillment-detail-card_title {
    width: 100%;
    max-width: 200px;
}

@media (max-width: 608px) {
    .fulfillment-detail-card {
        flex-direction: column;
    }
}
</style>
